//@flow
import APIFetcher from './APIFetcher';
import MultiAPIFetcher from './MultiAPIFetcher';

export { APIFetcher, MultiAPIFetcher };
export default APIFetcher;
